const styles = {
    headerSection: {
        p: 4,
        mb: 4,
        borderRadius: 2,
        backgroundColor: 'primary.main',
        color: '#fff',
    },
    filterSelect: {
        backgroundColor: 'rgba(255,255,255,0.1)',
        color: '#fff',
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255,255,255,0.3)',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255,255,255,0.5)',
        },
        '& .MuiSelect-icon': {
            color: '#fff',
        },
        '& .MuiInputLabel-root': {
            color: 'rgba(255,255,255,0.7)',
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#fff',
        },
    },
    refreshButton: {
        fontSize: { xs: '0.8rem', sm: '0.875rem' },
        py: { xs: 0.75, sm: 1 },
        px: { xs: 1.5, sm: 2 },
        borderColor: 'rgba(255,255,255,0.5)',
        '&:hover': {
            borderColor: '#fff',
            backgroundColor: 'rgba(255,255,255,0.1)',
        },
    },
    ratingsTable: {
        borderRadius: 2,
        overflow: 'hidden',
        width: '100%',
        minHeight: '400px',
    },
    loadingBox: {
        p: 8,
        textAlign: 'center',
    },
    emptyRatingsBox: {
        p: 8,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
    },
    emptyRatingsIcon: {
        fontSize: 64,
        color: 'text.secondary',
        mb: 3,
    },
    emptyRatingsText: {
        mb: 2,
    },
    dataGrid: {
        width: '100%',
        fontSize: '0.97rem',
        '& .MuiDataGrid-cell:focus': {
            outline: 'none',
        },
        '& .MuiDataGrid-columnHeaders': {
            backgroundColor: 'grey.100',
            fontSize: '1.05rem',
            fontWeight: 600,
            textAlign: 'center',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
            width: '100%',
            textAlign: 'center',
            justifyContent: 'center',
            display: 'flex',
        },
        '& .MuiDataGrid-row': {
            minHeight: 48,
            maxHeight: 60,
        },
        '& .MuiDataGrid-row:hover': {
            backgroundColor: 'grey.50',
        },
        '& .MuiDataGrid-cell': {
            py: 1,
            px: 1.5,
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
        },
    },
    dialogBox: {
        px: 3,
        py: 2,
    },
    messagePaper: {
        p: 3,
        mb: 3,
        backgroundColor: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: 2,
    },
    senderRecipientPaper: {
        p: 2,
        backgroundColor: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: 2,
        height: '100%',
    },
    dialogActions: {
        px: { xs: 2, sm: 3, md: 4 },
        py: 2,
        borderTop: '1px solid #eee',
        background: '#fafbfc',
        flexShrink: 0,
    },
    dialogButton: {
        px: 3,
        py: 1,
        borderRadius: 2,
        textTransform: 'none',
        fontWeight: 500,
    },
};

export default styles; 